import { Box, AspectRatio } from '@chakra-ui/react'

const Video = () => {
  return (
    <Box>
      {/* Hero Main */}
      <AspectRatio ratio={16 / 9}>
        <iframe
          src="https://www.youtube.com/embed/T8IS8AFk8JY?si=zScJCXjhEaTRGLZ6"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </AspectRatio>
    </Box>
  )
}

export default Video
